var map = {
	"./admins/admins.scss": 2351,
	"./admins/dashboard.scss": 5048,
	"./admins/ideas.scss": 9013,
	"./challenges.scss": 4955,
	"./completion-pages.scss": 6015,
	"./demographic-surveys.scss": 7707,
	"./home.scss": 5236,
	"./ideas.scss": 3446,
	"./material-theme.scss": 697,
	"./vote-for-ideas.scss": 6844,
	"entrypoints/css/admins/admins.scss": 2351,
	"entrypoints/css/admins/dashboard.scss": 5048,
	"entrypoints/css/admins/ideas.scss": 9013,
	"entrypoints/css/challenges.scss": 4955,
	"entrypoints/css/completion-pages.scss": 6015,
	"entrypoints/css/demographic-surveys.scss": 7707,
	"entrypoints/css/home.scss": 5236,
	"entrypoints/css/ideas.scss": 3446,
	"entrypoints/css/material-theme.scss": 697,
	"entrypoints/css/vote-for-ideas.scss": 6844
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1938;